module.exports = {"activation.modal.content.text":"ログインしてサブスクリプションを有効にするまでお待ちください。","activation.modal.content.status":"有効化"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/components/ModalContent/Activation.json
// module id = 834
// module chunks = 0